import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface OnboardingProfile {
  health_area_id: string | null;
  onboarding_completed: boolean;
  email_confirmed: boolean;
}

const ONBOARDING_PROFILE_QUERY_KEY = ["onboarding-profile"] as const;

async function fetchOnboardingProfile(userId: string): Promise<OnboardingProfile | null> {
  const { data, error } = await supabase
    .from("profiles")
    .select("health_area_id, onboarding_completed, email_confirmed")
    .eq("id", userId)
    .single();

  if (error || !data) return null;

  return {
    health_area_id: data.health_area_id ?? null,
    onboarding_completed: data.onboarding_completed === true,
    email_confirmed: data.email_confirmed === true,
  };
}

export function useOnboardingProfile(userId: string | undefined) {
  return useQuery({
    queryKey: [...ONBOARDING_PROFILE_QUERY_KEY, userId ?? "none"],
    queryFn: () => fetchOnboardingProfile(userId!),
    enabled: !!userId,
    staleTime: 30 * 1000,
  });
}

export { ONBOARDING_PROFILE_QUERY_KEY };
